var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content",attrs:{"id":"nonprofitDisclaimer"}},_vm._l((_vm.disclaimers),function(disclaimer){return _c('p',{key:disclaimer.id,staticClass:"disclaimer-copy",domProps:{"innerHTML":_vm._s(disclaimer.copy)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }